import React from 'react';
import { Link } from 'react-router-dom';
import { t } from '../../utils/i18n';
import PageTabs from '../../ui/PageTabs';
export default function GameRpsTabs({ active }) {
  if (active === 'play') return <Link to="/game/rps" className="text-sm text-primary hover:underline">{t('header.nav.game')}</Link>;
  return <PageTabs label={t('game.title')} active={active} items={[
    { id: 'config', label: t('gameRps.tabs.config'), to: '/game/rps' },
    { id: 'ranking', label: t('gameRps.tabs.ranking'), to: '/game/rps?tab=ranking' },
  ]} />;
}
